export default {
  //"server_url": process.env.NODE_ENV === 'development' ? "http://18.138.63.247:10812" : "",
  server_url: process.env.NODE_ENV === 'development' ? 'http://localhost:3030' : '',
  server_key: 'outabox',
  socket_timeout: 36000000,
  theme: {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    peterBlue: '#114470',
    sidebarColor: '#114470',
  }
};



// WEBPACK FOOTER //
// ./src/config.js